import { BaseModel } from "models/BaseModel";
import { Address } from "./Address";
import { AddressProps, EstablishmentFields, EstablishmentProps } from "./types";

export class Establishment extends BaseModel {
	[EstablishmentFields.ID]: string;
	[EstablishmentFields.LEGAL_NAME]: string;
	[EstablishmentFields.TRADE_NAME]: string;
	[EstablishmentFields.CNPJ]: string;
	[EstablishmentFields.STATUS]: string;
	[EstablishmentFields.CREATED_AT]: string;
	[EstablishmentFields.ADDRESS]: AddressProps;
	[EstablishmentFields.IE]?: number;
	[EstablishmentFields.CONTACT_PHONE]?: number;
	[EstablishmentFields.CONTACT_WHATSAPP]?: number;
	[EstablishmentFields.CONTACT_INSTAGRAM]?: string;
	[EstablishmentFields.CONTACT_FACEBOOK]?: string;
	[EstablishmentFields.SITE_URL]?: string;
	[EstablishmentFields.TERM]?: string;
	[EstablishmentFields.RESPONSIBLE_NAME]?: string;
	[EstablishmentFields.RESPONSIBLE_PHONE]?: number;
	[EstablishmentFields.RESPONSIBLE_EMAIL]?: string;
	[EstablishmentFields.RESPONSIBLE_CPF]?: string;
	[EstablishmentFields.RESPONSIBLE_ROLE]?: string;
	[EstablishmentFields.REMARK]?: string;
	[EstablishmentFields.UPDATED_AT]?: string;
	[EstablishmentFields.UPDATED_BY]?: string;
	[EstablishmentFields.IMAGE]: string;

	constructor(data: EstablishmentProps) {
		super(data);

		this[EstablishmentFields.ID] = data[EstablishmentFields.ID];
		this[EstablishmentFields.LEGAL_NAME] = data[EstablishmentFields.LEGAL_NAME];
		this[EstablishmentFields.TRADE_NAME] = data[EstablishmentFields.TRADE_NAME];
		this[EstablishmentFields.CNPJ] = data[EstablishmentFields.CNPJ];
		this[EstablishmentFields.STATUS] = data[EstablishmentFields.STATUS];
		this[EstablishmentFields.CREATED_AT] = data[EstablishmentFields.CREATED_AT];
		this[EstablishmentFields.IE] = data[EstablishmentFields.IE];
		this[EstablishmentFields.CONTACT_PHONE] =
			data[EstablishmentFields.CONTACT_PHONE];
		this[EstablishmentFields.CONTACT_WHATSAPP] =
			data[EstablishmentFields.CONTACT_WHATSAPP];
		this[EstablishmentFields.CONTACT_INSTAGRAM] =
			data[EstablishmentFields.CONTACT_INSTAGRAM];
		this[EstablishmentFields.CONTACT_FACEBOOK] =
			data[EstablishmentFields.CONTACT_FACEBOOK];
		this[EstablishmentFields.SITE_URL] = data[EstablishmentFields.SITE_URL];
		this[EstablishmentFields.TERM] = data[EstablishmentFields.TERM];
		this[EstablishmentFields.RESPONSIBLE_NAME] =
			data[EstablishmentFields.RESPONSIBLE_NAME];
		this[EstablishmentFields.RESPONSIBLE_PHONE] =
			data[EstablishmentFields.RESPONSIBLE_PHONE];
		this[EstablishmentFields.RESPONSIBLE_EMAIL] =
			data[EstablishmentFields.RESPONSIBLE_EMAIL];
		this[EstablishmentFields.RESPONSIBLE_CPF] =
			data[EstablishmentFields.RESPONSIBLE_CPF];
		this[EstablishmentFields.RESPONSIBLE_ROLE] =
			data[EstablishmentFields.RESPONSIBLE_ROLE];
		this[EstablishmentFields.REMARK] = data[EstablishmentFields.REMARK];
		this[EstablishmentFields.UPDATED_AT] = data[EstablishmentFields.UPDATED_AT];
		this[EstablishmentFields.UPDATED_BY] = data[EstablishmentFields.UPDATED_BY];
		this[EstablishmentFields.IMAGE] = data[EstablishmentFields.IMAGE];

		this[EstablishmentFields.ADDRESS] =
			data.address && new Address(data.address);
	}
}
